export const tokens = {
    list: {
        gap: {
            parent: 16,
            child: 10,
        },
    },
    item: {
        gap: 10,
    },
    label: {
        size: 14,
    },
};
